import {Injectable} from '@angular/core';
import MessagingAccount from '../../model/messagingAccount.model';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, switchMap} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import MessagingFolder from '../../model/messagingFolder.model';
import {split} from '@angular-devkit/core';

@Injectable()
export default class MessagingFolderService {
    public constructor(private http: HttpClient) {
    }
    list(account: MessagingAccount, useCache?: boolean): Observable<MessagingFolder[]> {
        useCache = useCache || false;
        const url = environment.apiUrl + '/messaging/folders?account=' + account.id;
        const timestamp = Date.now();
        if(useCache) {

        }
        return this.http.get<MessagingFolder[]>(url).pipe(switchMap(result => {
            result = this.sanitizeFolders(result);
            return of(result);
        }));
    }

    private sanitizeFolders(folders) {
        let changed = false;
        let maxDepth = 0;
        for(let f of folders) {
            let currentDepth = f.path.split(f.delimiter).length;
            if(currentDepth > maxDepth) { maxDepth = currentDepth; }
        }
        for(let f of folders) {
            if(f.parentPath && f.path.split(f.delimiter).length == maxDepth) {
                let found = false;
                for(let f1 of folders) {
                    if(f1.path == f.parentPath) {
                        found = true;
                        if(typeof f1.subfolders == 'undefined') {
                            f1.subfolders = [f];
                        } else {
                            f1.subfolders.push(f);
                        }
                        folders.splice(folders.indexOf(f), 1);
                        changed = true;
                    }
                }

                if(!found) {
                    let parentOfParent = f.parentPath.split(f.delimiter);
                    let folderName = parentOfParent.splice(parentOfParent.length - 1, 1)[0];
                    parentOfParent = parentOfParent.join(f.delimiter);
                    folders.push({
                        path: f.parentPath,
                        delimiter: f.delimiter,
                        listed: false,
                        name: folderName,
                        parentPath: parentOfParent
                    });
                }
            }
        }

        if(changed) {
            return this.sanitizeFolders(folders);
        } else {
            return this.recursiveMapFolders(folders);
        }
    }

    private recursiveMapFolders(folders) {
        for(let i = 0; i < folders.length; i++) {
            let name = folders[i].name;
            let specialUse = typeof folders[i].specialUse != 'undefined' ? folders[i].specialUse.replace(/\\/g, '').toUpperCase() : null;
            switch(specialUse) {
                case 'INBOX': name = 'Posteingang'; break;
                case 'SENT': name = 'Postausgang'; break;
                case 'TRASH': name = 'Papierkorb'; break;
                case 'DRAFT': name = 'Entwurf'; break;
                case 'JUNK': name = 'Spam'; break;
            }
            folders[i] = {
                realName: folders[i].path,
                specialUse: specialUse,
                displayName: name,
                subfolders: typeof folders[i].subfolders != 'undefined' ? this.recursiveMapFolders(folders[i].subfolders) : []
            } as MessagingFolder;
        }
        return folders;
    }
}
